import React, {useState} from 'react';
import style from './style.scss'

const ColorGroup = (props) => {

{/*
    const {field,type="checkbox"} = props;

    return (<div className={style.typeColorGroup}>

        <label className={style.formLabel}
            htmlFor={field.elementId}>
            {field.label}{field.required&&<span className={style.asterisk}> *</span>}
        </label>

         {field.options && field.options.map((option, i) => {
            return (
                <label key={i} className={style.formField}>
                   <div className={style.color}>
                       <span>{option.label}</span>
                   </div>
                </label>
            );
        })}

    </div>)
*/ }

const {field} = props;
const img_size_style = ((field.disp_size_img > 0) ? {width: `${field.disp_size_img  }px`} : {});

const [other, setOther] = useState(false);
const [selected, setSelected] = useState({});

const type = field.multiple ? 'checkbox' : 'radio';
return (<div className={style.typeImgGroup}>

<label className={style.formLabel}
    htmlFor={field.elementId}>
    {field.label}{field.required&&<span className={style.asterisk}> *</span>}
</label>

    <div className={`${style.typeImgGroup} ${field.makeinline ? style.inline : ''}`}>

        {field.options.map((option, i) => {

            return (
                <div
                    key={i}
                    className={`${style.image  } ${  (selected[i] || option.selected) ? style.selected : ''  } ${ style[field.disp_type]} ${ style[field.img_selection_type]}`} //
                    onClick={() => {
                        if (field.multiple) {
                            selected[i] = selected[i] ? !selected[i] : true;
                            setSelected(selected);
                        } else {
                            setSelected({[i]: true});
                        }

                    }
                    }
                >

                    <div
                      className={style.colorArea}
                      style={{width: `${field.disp_size_img  }px`, height: `${field.disp_size_img  }px`, background: option.color}}
                    >
                    </div>
                    <label>{option.label}</label>
                </div>
            );
        })}

        {field.other && <label className={style.checkBox}><input name={field.name}
                                                                 onChange={(ele) => {
                                                                     setOther(ele.target.checked)
                                                                 }} type={type}/>{wp.i18n.__('Other')}</label>}
        {field.other && other && <label><input type="text"/></label>}
    </div>
</div>)






}

export default ColorGroup;
